export const DAYJS_MAP = {
  en: 'en',
  zh_CN: 'zh-cn'
}

export const BASE_BOOLEAN = [
  { value: 0, label: '否' },
  { value: 1, label: '是' }
]

function BaseRender<T = unknown>(text: T, fn: BD.Fn<T>) {
  if (text === undefined) {
    return undefined
  } else {
    return fn(text)
  }
}
export const BaseBooleanStatusRender = (val, text = ['否', '是']) => {
  return BaseRender(val, t => (t ? text[1] : text[0]))
}

export const BaseBooleanStatusColorRender = text => {
  return BaseRender(text, t => (t ? 'success' : 'error'))
}

export const TOP_ID = '0'
/** 仁寿县中心经纬度 */
export const RS_CENTER_LNG_LAT: [number, number] = [104.131573, 29.998239]
/** 简单的审核状态 */
export enum SIMPLE_REVIEW_STATUS {
  PENDING = -1,
  REJECT = 0,
  RESOLVE = 1
}
export const SIMPLE_REVIEW_STATUS_LABEL = {
  [SIMPLE_REVIEW_STATUS.PENDING]: '待审核',
  [SIMPLE_REVIEW_STATUS.REJECT]: '已驳回',
  [SIMPLE_REVIEW_STATUS.RESOLVE]: '已办结'
}
export const SIMPLE_REVIEW_STATUS_COLOR = {
  [SIMPLE_REVIEW_STATUS.PENDING]: 'warning',
  [SIMPLE_REVIEW_STATUS.REJECT]: 'error',
  [SIMPLE_REVIEW_STATUS.RESOLVE]: 'success'
}
